import React from "react";
import {
  Box,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

export default function AveragedExpandedRowContent({
  open,
  colSpan,
  headers,
  columnWidths,
  components,
  renderRow,
}) {
  const columnCount = headers.reduce(
    (count, header) =>
      count + (typeof header === "object" ? header.colSpan || 1 : 1),
    0,
  );
  const usesFixedColumnLayout = columnWidths?.length === columnCount;

  return (
    <TableRow style={{ backgroundColor: "#ffffff" }}>
      <TableCell
        style={{
          paddingBottom: 0,
          paddingTop: 0,
          backgroundColor: "#ffffff",
        }}
        colSpan={colSpan}
      >
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box margin={1}>
            <Table
              style={{
                backgroundColor: "#ffffff",
                ...(usesFixedColumnLayout ? { tableLayout: "fixed" } : {}),
              }}
            >
              {usesFixedColumnLayout && (
                <colgroup>
                  {columnWidths.map((width, index) => (
                    <col key={index} style={{ width }} />
                  ))}
                </colgroup>
              )}
              <TableHead>
                <TableRow style={{ backgroundColor: "#ffffff" }}>
                  {headers.map((header, index) => {
                    const label =
                      typeof header === "object" ? header.label : header;
                    const colSpan =
                      typeof header === "object" ? header.colSpan : undefined;
                    const align =
                      typeof header === "object" ? header.align : undefined;
                    const style =
                      typeof header === "object" ? header.style : undefined;

                    return (
                      <TableCell
                        key={index}
                        colSpan={colSpan}
                        align={align}
                        style={style}
                      >
                        {label}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>

              <TableBody>
                {components.map((component, index) => (
                  <TableRow
                    key={`collapsibleRow_${index}`}
                    style={{ backgroundColor: "#ffffff" }}
                  >
                    {renderRow(component, index)}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  );
}
